import logoutUser from "@casino/actions/logoutUser";
import useLogoutFromCognito from "@casino/client/hooks/useLogoutFromCognito";
import resetOptimoveOverlaySession from "@casino/client/optimove/resetOverlaySession";
import signOutOptimoveUser from "@casino/client/optimove/signOutUser";
import { notifyLogout } from "@casino/client/utils/authenticate/notifyAuth";
import nativeReplace from "@casino/client/utils/router/nativeReplace";
import { getCookie, removeCookie } from "@workspace/cookies/browser";
import { useCallback, useState } from "react";

const useLogout = (
  siteConfig: SiteConfig,
  cognitoConfig?: CognitoConfigFragment,
) => {
  const [showToast, setShowToast] = useState(false);
  const { pathPrefix = "", isBridgeSite } = siteConfig;
  const { isCognito, logoutFromCognito } = useLogoutFromCognito(
    isBridgeSite,
    cognitoConfig,
  );
  const homeUrl = pathPrefix || "/";

  const logout = useCallback(async () => {
    const token = getCookie("token");
    if (token) {
      await logoutUser();
    }
    notifyLogout();
    setShowToast(true);
    removeCookie("token");
    removeCookie("auth0.ssodata");
    signOutOptimoveUser();
    resetOptimoveOverlaySession();
    window.proto?.reset();
    if (window.gib) {
      window.gib.setAuthStatus(window.gib.IS_NOT_AUTHORIZED);
      window.gib.setSessionID("");
      window.gib.setIdentity("");
    }
    if (isCognito) {
      logoutFromCognito();
      return;
    }
    nativeReplace(homeUrl);
  }, [logoutFromCognito, isCognito, homeUrl]);
  return { logout, showToast, setShowToast };
};

export default useLogout;
